/**
 * A person's served name (TMMAPI-0140/0141): the display name or JSON `null`, never an email
 * substitute. Blank or whitespace is `null` too, so a render site has one rule —
 * `personName()` in `src/i18n/` — and never prints an empty name.
 */
export function personNameOrNull(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}
